window.slate = window.slate || {};
window.theme = window.theme || {};
window.custom = window.custom || {};



// WEBPACK FOOTER //
// ./src/scripts/src/global/variables.js